import { createContext } from "react";
import { Accumulator } from "../../models/Accumulator";
import { LastServiceDate } from "../../models/LastServiceDate";
import { PlanAllotment } from "../../models/PlanAllotment";

export type IAccumulatorContext = {
    accumulators: Accumulator[];
    lastServiceDates: LastServiceDate[];
    loading: boolean;
    planAllotments: PlanAllotment[];
};

const defaultValue: IAccumulatorContext = {
    accumulators: [],
    lastServiceDates: [],
    loading: false,
    planAllotments: [],
};
export const AccumulatorContext = createContext<IAccumulatorContext>(defaultValue);
